module.exports = __webpack_public_path__ + "img/geo.f6d93a74.png";